var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$uioverrides.logo)?_c('img',{attrs:{"src":_vm.$uioverrides.logo,"title":_vm.$uioverrides.name,"alt":_vm.$uioverrides.name}}):_c('nice-icon-2',{attrs:{"icon":"logo"}})
}
var staticRenderFns = []

export { render, staticRenderFns }